<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">{{ $t("PAYMENT_TERMS.PAYMENT_TERMS_LIST") }}</h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addpaymentTerm()"
                v-if="$currentUserCan($permissions.PERM_CREATE_PAYMENT_TERMS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("PAYMENT_TERMS.ADD_PAYMENT_TERM") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_PAYMENT_TERMS)"
                :objectType="'payment-terms'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <payment-term-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import PaymentTermListTable from "./partials/PaymentTermListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    PaymentTermListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addpaymentTerm() {
      this.$router.push({ name: "Add PaymentTerm" });
    },
  },
};
</script>
